import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";
import { scrollToId } from "@/lib/scrollTo";
import { cn } from "@/lib/utils";

const LINKS = [
  { id: "work", label: "Work" },
  { id: "services", label: "Services" },
  { id: "studio", label: "Studio" },
  { id: "process", label: "Process" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), open ? 250 : 0);
  };

  return (
    <header
      className={cn(
        "fixed top-0 inset-x-0 z-50 transition-all duration-500",
        scrolled ? "glass py-3" : "bg-transparent py-5"
      )}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              type="button"
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="hidden md:block">
          <button
            type="button"
            data-testid="nav-cta-button"
            onClick={() => go("brief")}
            className="btn-glow px-6 py-2.5 rounded-full bg-crimson text-white text-sm font-bold tracking-wide"
          >
            Start a Project
          </button>
        </div>
        <button
          type="button"
          data-testid="mobile-menu-button"
          className="md:hidden text-gray-900 p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden mx-4 mt-3 rounded-2xl border border-gray-100 bg-white shadow-soft p-5 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button
              key={l.id}
              type="button"
              data-testid={`mobile-nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-gray-700 font-medium"
            >
              {l.label}
            </button>
          ))}
          <button
            type="button"
            data-testid="mobile-nav-cta-button"
            onClick={() => go("brief")}
            className="px-6 py-3 rounded-full bg-crimson text-white font-bold"
          >
            Start a Project
          </button>
        </div>
      )}
    </header>
  );
}
